document.addEventListener("DOMContentLoaded", function () {

  function openSizeGuide(e) {
    const trigger = e.target.closest(".rxn-size-guide-trigger");
    if (!trigger) return;

    e.preventDefault();

    const modal = document.getElementById("rxn-size-guide-modal");
    if (!modal) return;

    modal.classList.add("active");
    document.body.style.overflow = "hidden";
  }

  function closeSizeGuide() {
    const modal = document.getElementById("rxn-size-guide-modal");
    if (!modal) return;

    modal.classList.remove("active");
    document.body.style.overflow = "";
  }

  // Open (Event Delegation)
  document.addEventListener("click", function(e){
    if(e.target.closest(".rxn-size-guide-trigger")){
      openSizeGuide(e);
    }
  });

  // Close
  document.addEventListener("click", function(e){

    if(e.target.closest(".rxn-size-guide-close")){
      closeSizeGuide();
      return;
    }

    if(e.target.classList.contains("rxn-size-guide-overlay")){
      closeSizeGuide();
      return;
    }

  });

  // ESC
  document.addEventListener("keydown", function(e){

    if(e.key === "Escape"){
      closeSizeGuide();
    }

  });

});




document.addEventListener("DOMContentLoaded",()=>{

const viewer=document.getElementById("rxn-viewers");

if(viewer){

setInterval(()=>{

viewer.innerHTML=Math.floor(Math.random()*8)+7;

},5000);

}

});